/**
 * Will check if your thing is located on panoramas currently active view/scene
 * @param panorama
 * @param sceneIndex
 * @param tourScene
 */
export function isLocatedOnPanoramaActiveView(panorama, sceneIndex, tourScene) {
    const activeTourGuid = panorama.getActiveTourSceneGuidView();
    const activeSceneIndex = panorama.getActiveSceneIndex();
    return activeTourGuid === tourScene && activeSceneIndex === sceneIndex;
}
